import React, { useEffect, useState } from "react";
import ServicesAreaTwoItem from "../../components/ServicesArea/ServicesAreaTwoItem";
import SlickSlider from "../../components/SlickSlider/SlickSlider";
import ServicesAreaThreeItem from "../../components/ServicesArea/ServicesAreaThreeItem";
import { imgconvert } from "../../helpers/imgconverter";
import ContactPageArea from "../../components/Contact/ContactPageArea";
import ContactMapArea from "../../components/Contact/ContactMapArea";
import Offisignup from "../officeform";
import axios from "axios";
import { API } from "../../config/urls";
import PricingArea from "../../components/PricingArea/PricingArea";
import FaqAreaOne from "../../components/FaqArea/FaqAreaOne";
import TeamAll from "../../components/Team/TeamAll";

const Detail = ({ data }) => {
  const slick_settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    autoplay: true,
    arrows: false,
    slidesToShow: data?.length,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: data?.length < 3 ? data?.length : 3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: data?.length < 3 ? data?.length : 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  const [pricing, setPricing] = useState();
  const [doctorList,setDoctorList] = useState()
  const GetPricing = () => {
    // var axios = require("axios");
    var config = {
      method: "get",
      url: API.getStandardPackage,
      headers: {},
    };
    axios(config)
      .then(function (response) {
        console.log(response);
        setPricing(response.data);
      })

      .catch(function (error) {
        console.log(error);
      });
  };

  const GetDoctorList = () => {
    // var axios = require("axios");
    var config = {
      method: "get",
      url: API.getDoctorList,
      headers: {},
    };
    axios(config)
      .then(function (response) {
        console.log(response);
        setDoctorList(response.data);
      })

      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    GetPricing();
    GetDoctorList()
  }, []);
  return (
    <>
      <div>
        {!data?.show_contact_form &&
          !data?.show_signup_form &&
          data?.block?.map((item, index) =>
            item?.pricing ? (
              <PricingArea data={pricing} />
            ) : item?.faqs ? (
              <FaqAreaOne data={item?.child_block?.[0]?.child_block} />
            ) : item?.child_block?.[0]?.child_block.length > 0 ? (
              item?.child_block?.[0]?.child_block?.length >= 3 ? (
                <section className="services-area-two pt-30 pb-10">
                  <div className="container">
                    <div className="row justify-content-center">
                      <div className="col-xl-6 col-lg-7">
                        <div className="section-title-two  text-center mb-65 tg-heading-subheading animation-style2">
                          <span className="sub-title">{item?.heading}</span>
                          <h2 className="title tg-element-title">
                            {item?.sub_heading}
                          </h2>
                        </div>
                      </div>
                    </div>
                    <div className="row justify-content-center">
                      {item?.child_block?.[0]?.child_block?.map((x, index) => (
                        <div key={index} className="col-lg-4 col-md-6">
                          <ServicesAreaTwoItem item={x} />
                        </div>
                      ))}
                    </div>
                  </div>
                </section>
              ) : (
                <section className="services-area-three pt-30">
                  <div
                    className="services-bg jarallax"
                    data-background="/img/bg/services_bg.jpg"
                  ></div>
                  <div className="container custom-container">
                    <div className="row justify-content-center">
                      <div className="col-xl-6 col-lg-7">
                        <div className="section-title-two white-title text-center mb-65 tg-heading-subheading animation-style2">
                          <span className="sub-title">{item?.heading}</span>
                          <h2 className="title tg-element-title">
                            {item?.sub_heading}
                          </h2>
                        </div>
                      </div>
                    </div>

                    <div className="services-item-wrap-two">
                      <div className="row services-active">
                        <SlickSlider settings={slick_settings}>
                          {item?.child_block?.[0]?.child_block?.map(
                            (x, index) => (
                              <div key={index} className="col-lg-3">
                                <ServicesAreaThreeItem item={x} />
                              </div>
                            )
                          )}
                        </SlickSlider>
                      </div>
                    </div>
                  </div>
                </section>
              )
            ) : (
              <section className="about-area has-animation pt-30 pb-10">
                <div className="container">
                  <div
                    className={`row justify-content-center ${
                      item?.image?.[0]?.position === "RIGHT"
                        ? "flex-row-reverse"
                        : ""
                    }`}
                  >
                    <div className="col-lg-7 col-md-10">
                      <div className="about-img-wrap">
                        {item?.image?.map((x, y) => (
                          <img
                            src={imgconvert(x && x.image)}
                            style={{ minHeight: "400px", maxHeight: "500px" }}
                            className={`wow ${(y = 0
                              ? "fadeInLeft"
                              : "fadeInUp")}`}
                            data-wow-delay=".2s"
                            alt=""
                          />
                        ))}
                        {/* <img
                     src="/img/telehealth/nurse.jpg"
                     className="wow fadeInLeft"
                     data-wow-delay=".2s"
                     alt=""
                   />
                   <img
                     src="/img/telehealth/streamline.jpg"
                     className="wow fadeInUp"
                     data-wow-delay=".6s"
                     alt=""
                   /> */}
                      </div>
                    </div>

                    <div className="col-lg-5">
                      <div className="about-content">
                        <div className="section-title ">
                          <span className="sub-title">
                            <svg
                              viewBox="0 0 41 44"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M35.2826 37.5886C36.6662 36.9737 38.8185 36.205 40.8939 36.205C38.8185 36.205 36.6662 35.4363 35.2826 34.8213C34.6676 33.4377 33.8989 31.2854 33.8989 29.21C33.8989 31.2854 33.1303 33.4377 32.5153 34.8213C31.1317 35.4363 28.9794 36.205 26.9039 36.205C28.9794 36.205 31.1317 36.9737 32.5153 37.5886C33.1303 38.9722 33.8989 41.1246 33.8989 43.2C33.8989 41.1246 34.6676 38.9722 35.2826 37.5886Z"
                                fill="currentcolor"
                              />
                              <path
                                d="M31.2085 13.5288C33.4377 12.5295 36.8968 11.2996 40.279 11.2996C36.8968 11.2996 33.4377 10.0698 31.2085 9.07046C30.2093 6.84128 28.9794 3.38221 28.9794 0C28.9794 3.38221 27.7495 6.84128 26.7502 9.07046C24.521 10.0698 21.0619 11.2996 17.6797 11.2996C21.0619 11.2996 24.521 12.5295 26.7502 13.5288C27.7495 15.758 28.9794 19.2171 28.9794 22.5993C28.9794 19.2171 30.2093 15.758 31.2085 13.5288Z"
                                fill="currentcolor"
                              />
                              <path
                                d="M16.6036 31.7467C19.2939 30.5936 23.5986 28.9794 27.6726 28.9794C23.5986 28.9794 19.2939 27.442 16.6036 26.2121C15.3737 23.5986 13.8363 19.294 13.8363 15.22C13.8363 19.294 12.2989 23.5986 11.069 26.289C8.37865 27.442 4.07402 29.0563 0 29.0563C4.07402 29.0563 8.37865 30.5936 11.069 31.8235C12.2989 34.4371 13.8363 38.7417 13.8363 42.8926C13.8363 38.7417 15.3737 34.4371 16.6036 31.7467Z"
                                fill="currentcolor"
                              />
                            </svg>
                            {item?.heading}
                          </span>

                          <h2 className="title">
                            {item?.sub_heading
                              ?.split(" ")
                              .slice(0, 3)
                              .join(" ")}{" "}
                            {/* One Stop Health{" "} */}
                            <span>
                              {item?.sub_heading?.split(" ")[3]}
                              {/* Telehealth */}
                              {/* <svg
                                viewBox="0 0 173 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M2 22.9998C8.5 14.2152 90 -14 172 14.2148"
                                  strokeWidth="3"
                                />
                              </svg> */}
                            </span>{" "}
                            {item?.sub_heading?.split(" ").slice(4).join(" ")}
                          </h2>
                        </div>

                        <div
                          style={{ lineHeight: "2.5rem" }}
                          className="h6 opacity-75 text-start"
                          dangerouslySetInnerHTML={{
                            __html: item && item.description,
                          }}
                        ></div>

                        {/* <div className="contact">
                     <span className="icon">
                       <i className="fas fa-phone-alt"></i>
                     </span>
                     <a href="tel:0123456789">1-888-452-1505</a>
                   </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )
          )}
      </div>
      {data?.doctors &&  <TeamAll data={doctorList?.all_doctors} />}
      {data?.show_contact_form && (
        <>
          <ContactPageArea />
          <ContactMapArea />
        </>
      )}
      {data?.show_signup_form && (
        <>
          <Offisignup />
        </>
      )}
    </>
  );
};

export default Detail;
